import { render, staticRenderFns } from "./MyOffilineRecallsTable.vue?vue&type=template&id=21b53d1a"
import script from "./MyOffilineRecallsTable.vue?vue&type=script&lang=js"
export * from "./MyOffilineRecallsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports